import ContentsTypes from "@shared/enums/contentsTypes";
import DescriptionCardWithLogoPreview from "@project/components/DescriptionCardWithLogo/DescriptionCardWithLogoPreview";
export const DescriptionCardWithLogo = {
    label: "Carte description avec logo",
    type: ContentsTypes.DESCRIPTION_CARD_WITH_LOGO,
    Preview: DescriptionCardWithLogoPreview,
    icon: "address-card",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Logo",
            key: "logo",
            type: ContentsTypes.IMAGE,
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.SHORT_TEXT,
            value: "",
        },
        {
            label: "Objectif",
            key: "goal",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
